import { Badge } from '@any-ui-react/core';
import type { BadgeProps, MantineColor } from '@mantine/core';

import { PerformanceReviewStage, PerformanceReviewVersion } from '@/common/graphql';
import { getPerformanceReviewStageLabel } from '@/common/types';

interface Props extends BadgeProps {
  stage?: PerformanceReviewStage;
  version?: PerformanceReviewVersion;
}

export const PerformanceReviewStageBadge = ({
  stage,
  version = PerformanceReviewVersion.Version_2,
  ...rest
}: Props) => {
  let color: MantineColor = 'red';

  switch (stage) {
    case PerformanceReviewStage.TargetSetting:
      color = 'yellow';
      break;
    case PerformanceReviewStage.TargetEvaluation:
      color = 'blue';
      break;
    case PerformanceReviewStage.Closed:
      color = 'green';
      break;
  }

  if (stage) {
    return (
      <Badge {...rest} color={color}>
        {getPerformanceReviewStageLabel(stage, version)}
      </Badge>
    );
  } else {
    return (
      <Badge {...rest} color={color}>
        Unknown
      </Badge>
    );
  }
};
